import en from './en.json';
import fr from './fr.json';

export const routerI18n = {
  fr,
  en,
};
